module.exports = __webpack_public_path__ + "static/media/ic-download.7889cd24.svg";